import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

import { Text } from "../../foundations/typography/Text";

export interface PopoverContentProps extends PropsWithChildren {
  testID?: string;
}

export function PopoverContent(props: PopoverContentProps) {
  return (
    <div className={styles.dialogContent} data-testid={props.testID}>
      {typeof props.children === "string" ? (
        <Text style="global/body-secondary" color="text-weak">
          {props.children}
        </Text>
      ) : (
        props.children
      )}
    </div>
  );
}

const styles = {
  dialogContent: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
    paddingBottom: "var(--space-2)",
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
    paddingTop: "var(--space-2)",
  }),
};
